module.exports = __webpack_public_path__ + "static/media/shop.91ca96c7.png";